import { render, staticRenderFns } from "./salesDiscount.vue?vue&type=template&id=60773c6a&"
import script from "./salesDiscount.vue?vue&type=script&lang=js&"
export * from "./salesDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports